import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=28406ead&scoped=true&"
import script from "./HomeTabs.vue?vue&type=script&lang=ts&"
export * from "./HomeTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTabs.vue?vue&type=style&index=0&id=28406ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28406ead",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('28406ead', component.options)
    } else {
      api.reload('28406ead', component.options)
    }
    module.hot.accept("./HomeTabs.vue?vue&type=template&id=28406ead&scoped=true&", function () {
      api.rerender('28406ead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HomeTabs.vue"
export default component.exports